import { useContext, useMemo } from 'react';

import { t } from '@lingui/macro';

import { CoreContext } from '../context/CoreContext';
import useReadTeam from './useReadTeam';

export const PAYMENT_LINK_METHOD = 'payment_link';
export const PAYMENT_TERMINAL_METHOD = 'payment_terminal';

// We want to be able to select "no payment method"
// If so the backend will not create any payment
export const NO_PAYMENT_METHOD = 'none';

// even in connected mode, the staff may want to enter the credit card number of the client
// (like for a standard online payment)
export const ONLINE_PAYMENT_METHOD = 'payment_form';

// This is sent to get-checkout-data when we're disconnected
export const PAYMENT_WIDGET_METHOD = 'widget';

const useReadPaymentMethods = () => {
  const { coreData } = useContext(CoreContext);
  const { hasVendor } = useReadTeam();

  const noPaymentChoice = { label: t`None`, value: NO_PAYMENT_METHOD };
  const paymentLinkChoice = { label: t`Payment link`, value: PAYMENT_LINK_METHOD };

  const paymentMethods = useMemo(() => {
    if (coreData == null) return [];

    // If it's a staff with not enough rights we set the methods ourselves
    if (!coreData.show_all_payment_solutions) {
      // In manufacturer mode we'll allow None (the team might not have a vendor and we dont want paylink)
      if (coreData.is_manufacturer) return [noPaymentChoice];
      // Otherwise we'll allow staff to gen paylinks if there's a vendor
      return hasVendor ? [paymentLinkChoice] : [];
    }

    const choices = [noPaymentChoice];

    for (const [methodValue, methodLabel] of Object.entries(coreData.system_payment_methods)) {
      choices.push({ label: methodLabel, value: methodValue, is_system_method: true });
    }

    for (const [methodValue, methodLabel] of Object.entries(coreData.team_payment_methods)) {
      choices.push({ label: methodLabel, value: methodValue, is_system_method: false });
    }

    return choices;
  }, [JSON.stringify(coreData)]);

  return paymentMethods;
};

export default useReadPaymentMethods;
